import React from "react";

export default function Logo() {
    return <div className="footer__logo">
        <img src="https://nanoporetech.com/nano-assets/ont-logo-light.svg" alt="Oxford Nanopore Technologies"/>
    </div>;
}
